module.exports = __webpack_public_path__ + "static/media/products_services8.7192c8dc.jpg";